import React, { FC } from "react";
import { Card, Col, Divider, Row, Space } from "antd";
import Title from "antd/lib/typography/Title";
import { useIntl } from "react-intl";
import { ClockCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { Maybe } from "@graphql-tools/utils/typings/types";
import {
  Core_LocalizedStringMsg,
  Core_TimeFrameOfDayMsg,
  DayOfWeek,
  Patientportal_WeeklyScheduleMsg,
} from "../../src/generated/graphql";
import { WeekDaysTitles } from "../../helpers/enum-maps";
import { extractTranslation, formatTimeFrame } from "../../helpers/formatters";
import { useRouter } from "next/router";

interface FacilityOpeningHoursProps {
  openingHours:
    | Maybe<(Maybe<Patientportal_WeeklyScheduleMsg> | undefined)[]>
    | undefined;
  openingHoursFreeText: Maybe<Core_LocalizedStringMsg> | undefined;
}

export const FacilityOpeningHours: FC<FacilityOpeningHoursProps> = ({
  openingHours,
  openingHoursFreeText,
}) => {
  const { formatMessage } = useIntl();

  const router = useRouter();

  const dayOfWeekOpeningHoursMap = new Map<DayOfWeek, Core_TimeFrameOfDayMsg[]>(
    [
      [DayOfWeek.DayOfWeekMonday, []],
      [DayOfWeek.DayOfWeekTuesday, []],
      [DayOfWeek.DayOfWeekWednesday, []],
      [DayOfWeek.DayOfWeekThursday, []],
      [DayOfWeek.DayOfWeekFriday, []],
      [DayOfWeek.DayOfWeekSaturday, []],
      [DayOfWeek.DayOfWeekSunday, []],
    ]
  );

  openingHours?.forEach((openingHour) => {
    const weekDays = openingHour?.daysOfWeek;
    weekDays?.forEach((dayOfWeek) => {
      dayOfWeekOpeningHoursMap.get(dayOfWeek!)!.push(openingHour!.timeFrame!);
    });
  });

  const officeHourFreeText = extractTranslation(
    openingHoursFreeText,
    router.locale
  );

  return (
    <Card>
      <Title level={3}>
        {formatMessage({ id: "facility-selection.opening-hours.title" })}
      </Title>
      <Space style={{ width: "100%" }} direction={"vertical"} size={8}>
        {Array.from(dayOfWeekOpeningHoursMap.keys())?.map((dayOfWeek) => {
          const timeframes = dayOfWeekOpeningHoursMap.get(dayOfWeek);
          return (
            <Row key={dayOfWeek}>
              <Col span={12}>
                {formatMessage({ id: WeekDaysTitles.get(dayOfWeek)! })}
              </Col>
              <Col span={12} style={{ textAlign: "right" }}>
                {timeframes && timeframes.length > 0 ? (
                  <span>
                    <ClockCircleOutlined style={{ marginRight: 4 }} />
                    {timeframes
                      ?.map((timeFrame) => {
                        return formatTimeFrame(timeFrame);
                      })
                      .join(", ")}
                  </span>
                ) : (
                  <span style={{ color: "darkred" }}>
                    <CloseOutlined />
                    {formatMessage({ id: "facility-selection.closed" })}
                  </span>
                )}
              </Col>
            </Row>
          );
        })}
        {officeHourFreeText && officeHourFreeText.length > 0 && (
          <div>
            <Divider />
            <p>{officeHourFreeText}</p>
          </div>
        )}
      </Space>
    </Card>
  );
};
